import Cookies from 'js-cookie';
import { $, findParent, deleteItem } from '../utils/Utils';

const notice = (() => {
  const config = {
    dismiss: [...$('.js-noticeDismiss')],
    parentCN: 'js-noticeParent',
    containerCN: 'js-noticeContainer',
    cookieName: 'obo-closedNotifications',
    tolken: 'obo-',
  };

  const handleContainer = (container = 1) => {
    if (container.childElementCount < 1) {
      deleteItem(container);
    }
  };

  const dismiss = (trigger) => {
    const parent = findParent(trigger, config.parentCN);
    const container = parent.parentNode;
    // delete notice
    deleteItem(parent);
    // empty container if there is no notice to show
    handleContainer(container);
  };

  const handleDismiss = ({ e, d: trigger }) => {
    const ID = trigger.dataset.id.toLowerCase();
    const expDate = (trigger.dataset.expiry) ? parseFloat(trigger.dataset.expiry) : 365;

    e.preventDefault();

    if (ID === 'consent') {
      // set separate cookie for consent
      Cookies.set(`${config.tolken}${ID}`, `${ID}`, { expires: expDate });
    } else {
      const c = Cookies.get(config.cookieName);
      let arr = [];

      if (c !== undefined) {
        try {
          arr = JSON.parse(c);
        } catch (err) {}

        if (!arr.includes(ID)) {
          arr.push(ID);
        }
      } else {
        arr.push(ID);
      }
      try {
        arr = JSON.stringify(arr);
      } catch (err) {}

      Cookies.set(config.cookieName, arr, { expires: expDate });
    }

    dismiss(trigger);
  };

  const setup = () => {
    config.dismiss.forEach((d) => {
      d.addEventListener('click', e => handleDismiss({ e, d }));
    });
  };

  const init = () => {
    if (config.dismiss.length > 0) {
      setup();
    }
  };

  return {
    init,
  };
})();

export default notice.init();
